'use client';

import { retryLandingProvisioning } from '@/actions/tenants';
import { Tenant } from '@/payload-types';
import { reportError } from '@/utils/error-reporting';
import { Button, toast, useDocumentInfo, useField } from '@payloadcms/ui';
import { useState } from 'react';

const RetryLandingProvisioningButton = () => {
  const { id, data } = useDocumentInfo();
  const { setValue: setProvisioningStatus } = useField<Tenant['repositoryProvisioningStatus']>({
    path: 'repositoryProvisioningStatus',
  });
  const [isRetrying, setIsRetrying] = useState(false);
  const [hasRetried, setHasRetried] = useState(false);

  const tenant = data as Tenant | undefined;
  if (!id || !tenant?.name) return null;

  const handleRetry = async () => {
    try {
      setIsRetrying(true);
      const { ok } = await retryLandingProvisioning(String(id));
      if (!ok) throw new Error('Retry failed');
      setProvisioningStatus('pending', true);
      setHasRetried(true);
      toast.success('Provisioning retry triggered.');
    } catch (error) {
      reportError(error, {
        flow: 'retry-landing-provisioning',
        tenant_id: String(id),
        tenant_name: tenant.name,
      });
      toast.error('Something went wrong while retrying provisioning.');
    } finally {
      setIsRetrying(false);
    }
  };

  if (hasRetried) return null;

  return (
    <Button type="button" buttonStyle="primary" onClick={handleRetry} disabled={isRetrying}>
      {isRetrying ? 'Retrying…' : 'Retry provisioning'}
    </Button>
  );
};

export default RetryLandingProvisioningButton;
